import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Agencies } from 'app/models/agencies';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { PrimeNGConfig } from 'primeng/api';
import { SearchService } from 'app/services/search/search.service';
@Component({
  selector: 'app-agences-tunis',
  templateUrl: './agences-tunis.component.html',
  styleUrls: ['./agences-tunis.component.scss']
})
export class AgencesTunisComponent implements OnInit {

  @ViewChild('agencyForm', { static: false })
  closeResult = '';
  search_name1:any;
  public search: string  = ''
  agencyForm: NgForm;
  p: Number = 1;
  lengthSociete=10
  totalSociete : any

  agenciedData: Agencies;
  dataSource = new MatTableDataSource();
  displayedColumns: string[];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  isEditMode = false;
  public agencies:any
  public idAgency: any
  public Agency: any
  
  pageIndex:number = 0;
  pageSize:number = 50;
  lowValue:number = 0;
  highValue:number = 50; 
  AgenciesTunis:any

  constructor(private agenciesService: AgenciesService,
    private primengConfig: PrimeNGConfig,
    private searchService: SearchService ) { }

  ngOnInit() {
 
    this.getagencesTunis();

  }
  getagencesTunis() {
    this.agenciesService.getListAgenceTunis().subscribe((data: any) => {
      this.AgenciesTunis = data;
      console.log( this.AgenciesTunis);
      // Filtrer les promoteurs de Tunis
      this.agencies = this.AgenciesTunis
      .sort((a: any, b: any) => {
        // Sort based on the existence of projets array
        if (a.biens.length === 0 && b.biens.length > 0) {
          return 1; // Move agencie with empty biens to the end
        } else if (a.biens.length > 0 && b.biens.length === 0) {
          return -1; //   Move agencie with non-empty projets to the beginning
        } else {
          return 0; // No change in order
        }
      });

        
    });
  }
  




  cancelEdit() {
    this.isEditMode = false;
    this.agencyForm.resetForm();
  }

  deleteAgencies(agencie: any) {
    this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {

      console.log(this.dataSource.data);

    });
  
    
  }

  performSearch() {
    this.AgenciesTunis = this.searchService.search(this.AgenciesTunis, this.search);
  }
  }